
import Device from "./pages/Device/Device";
import UsersComponent from "./pages/Users/UsersComponentjs";
import UserComponent from "./pages/Users/UserComponent";
import LogPage from "./pages/Auth/LogPage";
import Devices from './pages/Devices/Devices'
import Login from "./pages/Auth/Login";
import Firmwares from "./pages/Firmwares/Firmwares";
import Failures from "./pages/Failures/Failures";

const AppRoutes = [
  {
    index: true,
    element: <Login/>
  },
  {
    path: '/devices',
    requireAuth: true,
    element: <Devices/>
  },
  {
    path: '/devices/:deviceId',
    requireAuth: true,
    element: <Device/>
  },
  {
    path: '/devices/:deviceId/logs',
    requireAuth: true,
    element: <LogPage/>
  },
  {
    path: '/firmwares',
    requireAdmin: true,
    element: <Firmwares/>
  },
  {
    path: '/failures',
    requireAdmin: true,
    element: <Failures/>
  },
  {
    path: '/users',
    requireAdmin: true,
    element: <UsersComponent/>
  },
  {
    path: '/users/:userId',
    requireAdmin: true,
    element: <UserComponent/>
  },
  // {
  //   path: '/dimmer/:deviceId',
  //   requireAuth: true,
  //   element: <DimmerPage/>
  // },
  // {
  //   path: '/mechanism/:deviceId',
  //   requireAuth: true,
  //   element: <MechanismPage/>
  // },
  {
    path: '/login',
    element: <Login/>
  },
];

export default AppRoutes;
